// COCHE §10.1.10 — 繁體中文 (香港). Translations TBD; copy of zh_cn until
// users (or the LLM bulk-translate tool) provide HK Traditional variants.
export default {
	common: {
		save: "儲存",
		cancel: "取消",
		delete: "刪除",
		edit: "編輯",
		search: "搜尋",
		export: "匯出",
		import: "匯入",
		confirm: "確定",
		yes: "是",
		no: "否",
		add: "新增",
		back: "返回",
		close: "關閉",
		operation: "操作",
		loading: "載入中…",
		empty: "沒有資料",
		opSuccess: "操作成功",
		opFailed: "操作失敗",
		submit: "提交",
		reset: "重設",
		reload: "重新整理",
		view: "查看",
		more: "更多",
		all: "全部",
		tip: "提示",
		confirmDelete: "確認是否刪除?",
		pleaseSelect: "請選擇",
		loadFailed: "載入失敗",
		downloadSuccess: "下載成功",
		warning: "警告",
		operationSuccess: "操作成功",
		pleaseInput: "請輸入",
		deleteSuccess: "刪除成功",
		editSuccess: "編輯成功",
		addSuccess: "新增成功",
		viewSource: "溯源",
		confirmDeleteRecord: "確定刪除當前記錄？",
		recordSeqHeader: "編號",
		detail: "詳情",
		requiredFieldHint: "缺少必填項，再次點擊提交定位至輸入欄。",
	},
	auth: {
		sessionExpired: "登入已過期，請重新登入。",
		permissionDenied: "您沒有執行此操作的權限。",
		networkError: "無法連接伺服器，請檢查網絡。",
	},
	login: {
		title: "登入",
		username: "用戶名",
		password: "密碼",
		submit: "登入",
		captcha: "驗證碼",
		rememberMe: "記住我",
		welcome: "歡迎登入",
		signIn: "登入",
		platformTitle: "科研資料庫平台",
		platformTagline: "高效採集、靈活易用的臨床科研資料解決方案",
		sxswTitle: "陝西省神經外科醫療質量控制中心資料填報系統",
		bgAlt: "背景圖",
		tabPassword: "密碼登入",
		tabSms: "驗證碼登入",
		tabWechat: "微信掃碼登入",
		usernamePh: "請輸入帳號",
		passwordPh: "請輸入密碼",
		mobilePh: "請輸入手機號",
		smsCodePh: "請輸入簡訊驗證碼",
		captchaPh: "圖形驗證碼",
		invalidMobile: "請輸入11位有效手機號",
		getCode: "取得驗證碼",
		resendCode: "{sec}秒後重新取得",
		smsSent: "驗證碼已傳送",
		copyright: "© 2026 北京醫合易生科技有限公司. 京ICP備 19052789-1",
		icpFiling: "京公網安備11011302007191",
		platformTitleMycoach: "臨床數據平台",
		platformTaglineMycoach: "Unlock Clinical Data",
		copyrightMycoach: "© 2026 Mycoach Health Limited. 保留所有權利。符合 HIPAA 與 PIPEDA 標準。",
	},
	nav: {
		dashboard: "工作台",
		patients: "病人",
		projects: "項目",
		schema: "模型",
		governance: "管治",
		settings: "設定",
		logout: "登出",
	},
	locale: {
		switcher: "語言",
		en_hk: "English",
		zh_hk: "繁體中文",
		zh_cn: "简体中文",
	},
	i18n: {
		schemaTranslate: {
			title: "模型多語言翻譯",
			scanProject: "掃描項目缺失",
			draftWithLlm: "AI 起草",
			applySelected: "儲存所選",
			columnSource: "原文",
			columnSuggestion: "AI 建議",
			columnEdited: "您的修改",
			noMissing: "該項目所有欄位均已翻譯。",
		},
	},
	imaging: {
		title: "影像查看器",
		studies: "檢查",
		series: "序列",
		viewer: "查看器",
		reload: "重新整理",
		loading: "載入中…",
		prev: "上一張",
		next: "下一張",
	},
	timeseries: {
		title: "生理信號",
		streams: "信號流",
		viewer: "查看器",
		reload: "重新整理",
	},
	encryption: {
		title: "加密狀態",
		enabled: "已啟用",
		disabled: "未啟用",
		mysql: "MySQL",
		reload: "重新整理",
		encryptAll: "加密全部",
		decryptAll: "解密全部",
	},
	header: {
		maskedHospital: "****醫院",
		systemAdminConsole: "系統管理控制台",
		switchTenant: "切換租戶",
		configForm: "配置表單",
		switchProject: "切換項目",
		setPassword: "設定密碼",
		changePassword: "修改密碼",
		avatarSettings: "頭像設定",
		settings: "設定",
		logout: "登出",
		oldPassword: "原密碼",
		newPassword: "新密碼",
		confirmPassword: "確認密碼",
		enterOldPassword: "請輸入原密碼",
		enterNewPassword: "請輸入新密碼",
		enterConfirmPassword: "請再次輸入新密碼",
		passwordMismatch: "兩次密碼不一致",
		tenantCodePrompt: "輸入租戶編碼（必須是正確的租戶編碼）",
		passwordSetSuccess: "密碼設定成功，請重新登入",
		passwordChangeSuccess: "密碼修改成功，請重新登入",
		compactMode: "緊湊模式",
		compactModeDesc: "表單欄位橫向排列，行距更緊湊",
		darkMode: "深色模式",
		darkModeDesc: "僅本機生效，重新整理後保留",
		dataMasking: "資料脫敏",
		dataMaskingDesc: "在列表/表單中隱藏敏感欄位",
		fontTheme: "字型主題",
		fontThemeDesc: "選擇更現代的中英文字型組合，僅本機生效，立即套用",
		fontThemeModern: "現代",
		fontThemeEditorial: "嚴謹",
		fontThemeFriendly: "清新",
		betaSuffix: "（BETA）",
		languageDesc: "介面語言，切換後頁面會自動重新整理",
		changePasswordDesc: "更新登入密碼，修改後需重新登入",
		avatarSettingsDesc: "上傳或更換頭像圖片",
		modify: "修改",
		displayName: "顯示名稱",
		displayNameDesc: "應用中顯示的名稱；登入使用者名稱不可更改",
		editDisplayName: "修改顯示名稱",
		displayNamePlaceholder: "請輸入顯示名稱",
		displayNameRequired: "請輸入顯示名稱",
		displayNameLength: "顯示名稱長度需為 1–120 個字元",
		displayNameUpdated: "顯示名稱已更新",
		sectionAccount: "帳戶",
		sectionAppearance: "外觀",
		sectionPrivacy: "私隱",
	},
	followup: {
		title: "隨訪列表",
		statTotalCase: "病例總量",
		statMonthlyDue: "本月應到期訪視",
		statMonthlyDone: "本月已完成訪視",
		statMonthlyOpen: "本月未完成訪視",
		searchDate: "隨訪日期：",
		searchStatus: "隨訪狀態：",
		searchPatient: "患者姓名/編號：",
		startDate: "開始時間",
		endDate: "結束時間",
		select: "請選擇",
		input: "請輸入",
		searchBtn: "查 詢",
		resetBtn: "重 置",
		colIndex: "序號",
		colVisitPlan: "訪視計劃預覽",
		colPatientName: "患者姓名",
		colPatientNo: "患者編號",
		colVisitDate: "隨訪日期",
		colVisitName: "訪視名稱",
		colStatus: "隨訪狀態",
		colCenter: "所屬中心",
		colOperation: "操作",
		actEdit: "編輯",
		actView: "查看",
		actCancel: "取消隨訪",
		statusPending: "未隨訪",
		statusOverdue: "已超窗",
		statusDone: "已隨訪",
		fieldKeyword: "請輸入關鍵字",
		detailTitle: "隨訪詳情",
	},
	multicenter: {
		overviewTitle: "多中心概覽",
		patientTitle: "多中心患者列表",
		followupTitle: "多中心隨訪管理",
		colCenter: "中心",
		colTenant: "租戶",
		colPatientCount: "病例數",
		colFollowupCount: "隨訪數",
		colCompleteness: "完整度",
		switchProject: "切換項目",
		statCenters: "中心數量",
		statPatients: "患者總數量",
		statFollowups: "隨訪總次數",
		statOverdue: "過期未隨訪",
		newPatientTrend: "患者新增趨勢",
		today: "今日",
		thisWeek: "本週",
		thisMonth: "本月",
		thisYear: "全年",
		startDate: "開始日期",
		endDate: "結束日期",
		dateSep: "至",
		centerPatientCount: "中心患者數量",
		colRank: "排名",
		colCenterName: "中心名稱",
		colUserCount: "用戶數",
		colPatientCountAlt: "患者數量",
		patientGender: "患者性別",
		mcInfo: "多中心資訊",
		caseCount: "病例數",
		departmentCount: "科室",
		mapCenters: "多中心分佈圖",
		mapPatients: "患者區域分佈圖",
		caseFilter: "病例數量篩選",
		all: "ALL",
		hospitalName: "醫院名稱：",
		departmentName: "科室名稱：",
		projectName: "項目名稱：",
		patientCountLabel: "病例數量：",
		emptyData: "暫無資料",
	},
	manage: {
		auditLog: "審計日誌",
		piiRule: "PII規則配置",
		governanceInbox: "審批收件匣",
		myRequests: "我的申請",
		scopeTree: "組織架構",
		lifecycle: "生命週期",
		metadataVersioning: "模型版本",
		ingestionHardening: "匯入加固",
		subCenter: "分中心",
		schema: "架構生成",
		agentConfig: "Agent設定",
		random: "隨機化",
	},
	databaseConfig: {
		patientBasicInfo: "患者基本資訊配置",
		databaseSection: "資料庫配置",
		followupSection: "隨訪表配置",
		colNo: "序號",
		colFormCode: "表單編碼",
		colFormName: "表單名稱",
		colModelCount: "模型數",
		colOp: "操作",
		colFollowupCode: "隨訪表單編號",
		colFollowupName: "隨訪表單名稱",
		colFollowupPlan: "關聯隨訪計劃",
		colFollowupPlanName: "關聯隨訪計劃名稱",
		btnAdd: "新增",
		btnBatchAdd: "批量新增",
		btnDelete: "刪除",
		btnEdit: "編輯",
		btnConfig: "配置",
		btnConfigFromTemplate: "從範本配置",
		btnConfigFromForm: "從項目表單配置",
		dlgEditTitle: "編輯",
		dlgAddTitle: "新增",
		dlgEditFollowupTitle: "編輯隨訪表",
		dlgAddFollowupTitle: "新增隨訪表",
		dlgFormName: "表單名稱",
		dlgFollowupName: "隨訪表單名稱",
		dlgPh: "請輸入",
		dlgCancel: "取消",
		dlgConfirm: "確定",
	},
	memberPermissions: {
		title: "人員權限",
		colNo: "序號",
		colTenant: "租戶",
		colUsername: "用戶名",
		colNickname: "暱稱",
		colFuncPermission: "功能權限",
		colDataPermission: "數據權限",
		colActions: "操作",
		btnConfigure: "配置",
		btnEdit: "修改",
		noRolesAssigned: "（未分配角色）",
		canDelete: "可刪除",
		cannotDelete: "不可刪除",
		scopeCount: "範圍：{f} 個表單 · {m} 個模型",
		actEditRoles: "編輯功能權限",
		actEditData: "編輯數據權限",
		actRemove: "移除醫生",
		confirmRemove: "確認移除當前醫生?",
		dlgAddTitle: "多中心人員管理",
		addHint: "輸入精確的 用戶名/工號/手機號 進行搜尋；新增後可在右側表格設定功能權限與數據權限。",
		searchPh: "請輸入精確的 用戶名/工號/手機號…",
		searchNoMatch: "未找到符合的用戶 — 請檢查拼寫或使用準確帳號",
		lblAccount: "帳號",
		btnAddAnother: "新增",
		dlgFuncTitle: "功能權限配置",
		projectRolesLabel: "項目範圍內的角色（可在此編輯）",
		globalRolesLabel: "全局生效的角色（請在「用戶管理」中編輯）",
		globalRolesHint: "這些角色是在用戶層級分配的，對所有項目都生效。請在用戶管理頁中維護，本處僅作唯讀展示。",
		projectRolesEmptyButGlobal: "該用戶尚未分配項目級角色，其在本項目的權限完全來自上方的全局角色。如需為本項目單獨授權，請在此選擇。",
		projectRolesEmptyNoGlobal: "該用戶尚未分配任何角色，請在此選擇以授予項目級權限。",
		dlgDataTitle: "數據權限配置",
		dataBypassModelAdmin: "提示：該用戶擁有 Model Administrator 角色，會完全繞過數據權限過濾。下方的選擇會被保存，但在瀏覽時不會生效——這些設定僅對沒有 Model Administrator 角色的用戶起作用。",
		dataBypassProjectCreator: "提示：該用戶是本項目的創建人，會完全繞過數據權限過濾。下方的選擇會被保存，但在瀏覽時不會生效——項目創建人始終可以看到全部表單與模型。",
		opPermissionLabel: "操作權限",
		opRead: "唯讀",
		opModify: "讀寫",
		deletePermissionLabel: "刪除權限",
		sodWarnTitle: "職責分離警告 ({n} 項衝突) — 仍可保存",
		sodErrorTitle: "職責分離衝突 ({n} 項) — 該項目已開啟強制校驗，無法保存",
		sodEnforceBlocked: "職責分離衝突 — 請移除衝突角色後再保存",
		sodWarnSaved: "已保存，但存在 {n} 項職責分離警告",
	},
	sod: {
		tagPending: "（待新增）",
		tagAssigned: "（已分配）",
		violationLine: "{a} 與 {b} 衝突 ({classA} × {classB})",
	},
	scopeTree: {
		filterTenantPh: "按租戶篩選",
		visibilityTitle: "我的可見範圍",
		visibilityPrompt: "點擊『重新整理』查詢目前會話的可見項目集",
		fUserId: "用戶 ID",
		fBypass: "繞過過濾",
		bypassYes: "是 (bypass)",
		bypassNo: "否 (enforced)",
		fReason: "原因 (reason)",
		fScopePaths: "Scope paths",
		noScopePath: "— 無 scope_path 分配 —",
		fAllowedProjects: "可見項目 ID",
		bypassAll: "— bypass: 全部可見 —",
		noVisibleProject: "無可見項目 (allowed-set is empty)",
		emptyTree: "暫無組織架構數據",
		rootLabel: "全部組織",
		tagDefault: "預設",
		tagProjectCount: "{n} 項目",
		truncated: "結果已截斷 (>1000 節點)。請使用單層介面分頁載入。",
		selectHint: "請在左側選擇一個節點以查看詳情",
		dKind: "層級",
		dCode: "代碼",
		dTenant: "租戶",
		dRegulatory: "監管",
		dFederation: "聯邦模式",
		dAddress: "地址",
		dCountry: "國家",
		dRegion: "地區",
		dMission: "使命",
		dProjectCount: "所含項目數",
	},
	auditLog: {
		title: "審計日誌",
		refresh: "重新整理",
		startDate: "起始時間",
		endDate: "結束時間",
		category: "分類",
		verb: "動作 (verb)",
		targetType: "目標類型",
		outcome: "結果",
		actorUserId: "操作人 ID",
		dataSubjectId: "資料主體 ID (GDPR)",
		targetProjectCode: "項目代碼",
		search: "查詢",
		reset: "重設",
		empty: "暫無審計日誌",
		colTime: "時間",
		colActor: "操作人",
		colApp: "入口",
		colCategory: "分類",
		colVerb: "動作",
		colTarget: "目標",
		colOutcome: "結果",
		colDetail: "詳情",
		view: "查看",
		drawerTitle: "審計日誌詳情",
		eventSection: "事件",
		complianceSection: "合規元資料 (GDPR readiness)",
		integritySection: "完整性 (hash chain)",
		fId: "ID",
		fTime: "時間",
		fActor: "操作人",
		fIp: "IP",
		fApp: "入口",
		fCategory: "分類 / 動作",
		fOutcome: "結果",
		fFailureReason: "失敗原因",
		fTarget: "目標",
		fProject: "項目",
		fLawful: "lawful_basis",
		fSubject: "data_subject_id",
		fCrossBorder: "cross_border_transfer",
		yes: "是",
		no: "否",
		fDestCountry: "destination_country",
		fPrev: "prev_log_hash",
		fThis: "this_log_hash",
		changeRefSection: "關聯變更記錄",
		loadChange: "載入變更詳情",
		fTable: "表/集合",
		fPk: "主鍵",
		fOp: "操作",
		loadChangeFailed: "載入變更詳情失敗",
	},
	metaVer: {
		intro: "此頁面是 <a href=\"/api/cmdb-template/doc.html#/cmdb-metadata\" target=\"_blank\">/cmdb-metadata</a> 的唯讀檢視。版本/歷史快照按 spec §3 的三階段開關推出。規範見 extract/coche/specs/metadata-versioning.md。",
		tabLog: "評估日誌 (影子+執行)",
		tabTags: "標籤",
		tabAdapters: "格式適配器",
		colTarget: "目標",
		colPriorVer: "原版本",
		colNote: "備註",
		colCode: "編碼",
		colTag: "標籤",
		colDescription: "描述",
		colCreated: "建立時間",
		colExtensions: "副檔名",
		colName: "名稱",
		colEnabled: "啟用",
		on: "啟用",
		off: "停用",
	},
	lifecyclePage: {
		intro: "此頁面是 <a href=\"/api/cmdb-template/doc.html#/cmdb-lifecycle\" target=\"_blank\">/cmdb-lifecycle</a> 的唯讀檢視。策略和法律保留的建立走 API;執行嚴格通過審批工作流(§10.1.3)。規範見 extract/coche/specs/lifecycle-retention.md。",
		tabPolicies: "保留策略",
		tabHolds: "法律保留",
		tabLog: "評估日誌 (影子+執行)",
		colTargetType: "目標類型",
		colRetentionDays: "保留天數",
		colAgeAnchor: "年齡錨點",
		colAction: "處置動作",
		colEnabled: "啟用",
		colDescription: "描述",
		on: "啟用",
		off: "停用",
		colScope: "範圍",
		colTargetId: "目標 ID",
		colReason: "原因",
		colImposed: "施加時間",
		colReleased: "解除時間",
		active: "活躍中",
		colAgeDays: "年齡(d)",
		colRequest: "審批請求",
		colNote: "備註",
	},
	ingestion: {
		intro: "唯讀檢視。攝取硬化按 spec §3 的三階段開關推出(Phase A=休眠 / Phase B=影子 / Phase C=enforce)。SFTP 伺服器獨立 gated 在 <code>imles.ingestion.sftp.enabled</code>。規範見 extract/coche/specs/ingestion-hardening.md。",
		tabChecksum: "校驗碼 (SHA-256)",
		tabRejections: "拒絕佇列",
		tabDedup: "去重表",
		tabSftp: "SFTP 工作階段",
		hashPlaceholder: "按 SHA-256 查找 (64 hex)",
		colOssFile: "OSS 檔案",
		colBytes: "位元組",
		colSource: "來源",
		colUploaded: "上傳時間",
		colFilename: "檔名",
		colReason: "原因",
		colMode: "影子",
		colDetail: "詳細",
		colOriginFileId: "原始檔案 ID",
		colReuseCount: "複用次數",
		colFirstSeen: "首次",
		colLastReuse: "最近複用",
		colUser: "使用者",
		colAuth: "認證",
		colOpened: "開始",
		colClosed: "結束",
		colUploads: "上傳數",
		colTotalBytes: "總位元組",
		colCloseReason: "關閉原因",
	},
	dbConfig: {
		title: "資料庫配置",
		step1: "選擇資料庫模型",
		step2: "選擇輸出形式",
		step3: "配置表單/文件",
		step4: "配置欄位",
		selectedOutput: "選定輸出形式",
		structuredForm: "結構化表單",
		structuredF1: "· 按照自訂的表單匯出資料",
		advFilter: "· 支援進階檢索",
		univariate: "· 支援單變量統計分析",
		crfExport: "· 根據資料生成CRF表格，可匯出PDF/Word文件",
		defaultForm: "預設表單",
		defaultF1: "· 按照預設結構顯示表單",
		formConfigTitle: "項目表單配置",
		formName: "項目表單名稱",
		formCode: "項目表單編碼",
		formOrder: "項目表單排序",
		visible: "是否顯示",
		formModelConfigTitle: "項目表單模型配置",
		selectModel: "選擇模型",
		newModel: "新增模型",
		colIndex: "序號",
		modelCode: "模型編碼",
		modelName: "模型名稱",
		modelDomain: "模型領域",
		modelOrder: "模型排序",
		modelConfigTitle: "項目模型配置",
		modelNameLabel: "項目模型名稱",
		modelCodeLabel: "*項目模型編碼",
		modelCodeLabelReq: "項目模型編碼",
		dontModify: "非必要情況請勿修改",
		deletionMode: "刪除方式",
		logical: "邏輯",
		physical: "物理",
		modelDescription: "模型描述",
		showNoteInput: "顯示註釋輸入框",
		note: "註釋",
		sceneType: "場景類型",
		sceneDefault: "預設場景",
		sceneTable: "表格場景",
		sceneTableDialog: "表格彈窗場景",
		sceneList: "列表場景",
		uploadAttachment: "上傳附件",
		on: "開",
		off: "關",
		saveModelAttrs: "儲存模型屬性",
		editFields: "編輯欄位",
		modelFieldConfigTitle: "項目模型欄位配置",
		previous: "上一步",
		next: "下一步",
		selectedInfo: "目前選定資訊",
		availableInfo: "可選資訊內容",
		codeFormatHint: "請輸入字母、數字或底線",
		selectRowFirst: "請選擇一筆資料後新增",
		enterModelName: "請輸入項目模型名稱",
		enterModelCode: "請輸入項目模型編碼",
		modelCodeFormat: "模型編碼只能包含字母、數字和底線",
		saveFormFirst: "請先儲存表單資訊",
		modelCodeExists: "該模型編碼已存在",
	},
	fieldList: {
		colFieldOrder: "欄位排序",
		colIntegrityScore: "完整度分",
		colFieldCode: "欄位編碼",
		colFieldName: "欄位名稱",
		colFieldType: "欄位類型",
		colVisible: "是否顯示",
		colEditable: "是否可編輯",
		colRequired: "是否必填",
		colDictValue: "字典值",
		addField: "新增欄位",
		refField: "引用欄位",
		dlgEdit: "編輯",
		dlgAdd: "新增",
		order: "排序",
		noSorting: "不排序",
		reservedHint: "以下欄位編碼具有特殊含義，會自動對應到病人資訊表：",
		colMeaning: "含義",
		colDescription: "說明",
		reservedUniqueNote: "其中 <b>card_id</b>、<b>inpatient_id</b>、<b>outpatient_id</b> 具有唯一性約束，同一項目內不允許重複值，可用於防止重複錄入病人。",
		fieldNameZh: "欄位中文名",
		fieldNameEn: "欄位英文名",
		fieldAlias: "欄位別名",
		tailLabel: "尾部標籤",
		fieldDesc: "欄位解釋",
		controlsVisibility: "是否控制顯示",
		controlledFields: "受控欄位",
		optionCode: "選項編碼",
		optionName: "選項名稱",
		controlledFieldCount: "受控欄位數量",
		controlledModelCount: "受控模型數量",
		inFormEvent: "表單內事件",
		inModelEvent: "模型內事件",
		inModelClickEvent: "模型內click事件",
		showNoteInput: "顯示註釋輸入框",
		note: "註釋",
		subFieldList: "子欄位列表",
		refList: "引用列表",
		selectExisting: "選擇已有欄位",
		colIndex: "序號",
		colModifiedBy: "修改人",
		colModifiedAt: "修改時間",
		dlgSubEdit: "子欄位編輯",
		dlgSubAdd: "子欄位新增",
		existingFieldList: "已有欄位列表",
		fieldControlled: "欄位受控",
		modelControlled: "模型受控",
		colFieldId: "欄位ID",
		colModelId: "模型ID",
		colModelCode: "模型編碼",
		colModelName: "模型名稱",
		refSaved: "引用關係儲存成功",
		convertedToSub: "已修改為子欄位",
		none: "無",
		reserved: {
			name: { n: "姓名", d: "病人姓名" },
			gender: { n: "性別", d: "0=女, 1=男" },
			age: { n: "年齡", d: "病人年齡" },
			birthday: { n: "出生日期", d: "病人生日" },
			phone: { n: "手機號", d: "聯絡電話" },
			idNum: { n: "身份證號", d: "身份證號碼" },
			cardId: { n: "住院卡號", d: "唯一約束，不可重複" },
			inpatientId: { n: "門診號", d: "唯一約束，不可重複" },
			outpatientId: { n: "住院號", d: "唯一約束，不可重複" },
			admissionTime: { n: "入院時間", d: "日期類型" },
			enrollmentTime: { n: "入組時間", d: "日期類型" },
			diagnosis: { n: "診斷", d: "診斷資訊" },
			doctorId: { n: "醫生ID", d: "關聯醫生" },
			doctorName: { n: "醫生名字", d: "關聯醫生姓名" },
			hospitalName: { n: "所屬醫院", d: "醫院名稱" },
			status: { n: "病人狀態", d: "如：入組、出組" },
			statusCode: { n: "狀態編碼", d: "狀態對應編碼" },
		},
	},
	customColumn: {
		title: "設定自訂欄",
		searchFieldPh: "輸入檢索欄位的名稱",
		name: "名稱",
		order: "排序",
		visible: "是否顯示",
		description: "描述",
		propertyPath: "屬性路徑",
		selectProperty: "請選擇屬性",
		colIndex: "序號",
	},
	piiRule: {
		title: "PII 規則配置",
		currentProject: "目前項目",
		refresh: "重新整理",
		readonly: "只讀出口脫敏 (read-side anonymisation)",
		readonlyDesc: "規則僅在資料匯出與佇列檢索路徑上生效；落盤資料不變。預設 KEEP 表示原樣返回。具備 pii.unmask 權限的角色可繞過脫敏 (繞過會被記入審計)。",
		addRule: "新增規則",
		preview: "規則預覽",
		saveAll: "儲存全部修改",
		empty: "尚未配置任何 PII 規則",
		colField: "欄位編碼 (field_code)",
		colMode: "脫敏方式",
		colExample: "範例",
		colNote: "備註",
		colOperation: "操作",
		actDelete: "刪除",
		modeKeep: "保留原值 (預設)",
		modeMask: "掩碼",
		modeRedact: "佔位符替換",
		modePseudonym: "項目內確定性化名",
		modeHash: "SHA-256 雜湊 (12 hex)",
		modeSuppress: "完全刪除欄位",
		modeGeneralise: "分桶/分級泛化",
		previewMissingInput: "請填寫欄位與脫敏方式。",
		draftMissingFieldCode: "新增的規則必須填寫欄位編碼。",
		saveSummary: "已儲存 {saved} 條 · 刪除 {deleted} 條",
	},
	analytics: {
		overviewTitle: "分析概覽",
		datasetTitle: "資料集",
		encodingTitle: "欄位編碼",
		selectionTitle: "欄位篩選",
		algorithmTitle: "演算法執行",
		reportTitle: "統計報告",
		researchOverviewTitle: "分析概覽",
		libraryTitle: "研究資料",
		topicsTitle: "課題推薦",
		workbenchTitle: "分析工作台",
		refresh: "重新整理資料",
		empty: "暫無分析資料",
		statSamples: "樣本數",
		statFields: "欄位數",
		statAnalyses: "分析數",
		recentAnalyses: "最近分析",
		colName: "分析名稱",
		colType: "類型",
		colCreatedAt: "建立時間",
		colOperation: "操作",
		actView: "查看",
		viewDetail: "查看詳情",
		typeAlgorithm: "演算法執行",
		typeReport: "統計報告",
		errorProject: "項目資訊未找到",
		errorFetch: "取得資料失敗",
	},
	clinic: {
		operationOverview: "營運概覽",
		appointments: "加號申請",
		checkins: "報到列表",
		chatHistory: "聊天歷史",
		users: "門診用戶管理",
		refresh: "重新整理",
		today: "今日",
		last7d: "近7天",
		last30d: "近30天",
		last90d: "近90天",
		custom: "自訂",
		dateSep: "至",
		startDate: "開始日期",
		endDate: "結束日期",
		kpiTotalUsers: "累計用戶",
		kpiNewUsers: "期內新增用戶",
		kpiActiveUsers: "活躍用戶",
		kpiDeactivated: "已停用帳號",
		kpiSnapshot: "目前快照",
		kpiMessages: "期內訊息總數",
		kpiConversations: "期內對話總數",
		kpiUploads: "期內上傳病歷數",
		kpiFollowupMessages: "期內隨訪訊息",
		recentRegistrations: "近期註冊",
	},
	discern: {
		title: "AI辨識列表",
		uploader: "上傳用戶：",
		userType: "用戶類型：",
		identifyStatus: "辨識狀態：",
		confirmStatus: "確認狀態：",
		input: "請輸入",
		select: "請選擇",
		userDoctor: "醫生",
		userPatient: "患者",
		userSys: "管理員",
		statusUnfinished: "未完成",
		statusFinished: "已完成",
		statusPending: "待確認",
		statusConfirmed: "已確認",
		searchBtn: "查 詢",
		resetBtn: "重 置",
		qrCode: "二維碼",
		batchUpload: "批次上傳",
		colIndex: "序號",
		colUploader: "上傳用戶",
		colUserType: "用戶類型",
		colProject: "項目名稱",
		colFileCount: "圖片數量",
		colUploadTime: "上傳時間",
		colIdentifyStatus: "辨識狀態",
		colIdentifyTime: "辨識時間",
		colConfirmStatus: "確認狀態",
		colConfirmUser: "確認用戶",
		colConfirmTime: "確認時間",
		colOperation: "操作",
		actView: "查看",
		actConfirm: "確認",
		viewTitle: "AI辨識詳情",
		batchUploadTitle: "批次上傳",
		dropFiles: "將檔案拖到此處，或",
		clickUpload: "點擊上傳",
		fileTip: "僅支援 JPG/PNG，單檔案不超過 10MB",
		startUpload: "開始上傳",
	},
	governance: {
		title: "審批收件匣",
		myTitle: "我的申請",
		refresh: "重新整理",
		colId: "申請ID",
		colType: "類型",
		colRequester: "申請人",
		colCreatedAt: "申請時間",
		colStatus: "狀態",
		colOperation: "操作",
		actView: "查看",
		actApprove: "通過",
		actReject: "駁回",
		statusPending: "待審批",
		statusApproved: "已通過",
		statusRejected: "已駁回",
		statusCancelled: "已取消",
		drawerTitle: "申請詳情",
		approve: "通過",
		reject: "駁回",
		comment: "審批意見",
		commentPh: "請輸入審批意見",
		noPendingStep: "沒有待審批步驟",
		emptyCommentConfirm: "駁回建議填寫理由,確定空備註提交嗎?",
		confirmTitle: "確認",
		toastApproved: "已通過",
		toastRejected: "已駁回",
		quickConfirmBody: "{action} 申請 #{id}?",
		quickConfirmTitle: "確認操作",
	},

	basicInfo: {
		doctor: "負責醫生",
		maskedDoctor: "***醫生",
		hospital: "所屬機構",
		maskedHospital: "****醫院",
		input: "請輸入",
		enrollDate: "入組日期",
		select: "請選擇",
		status: "入組狀態",
		diagnosis: "診斷",
		diagnosisPh: "請輸入診斷",
	},
	patientInfo: {
		patientNo: "患者編號",
		randomNo: "隨機號",
		name: "姓名",
		gender: "性別",
		age: "年齡",
		ageUnit: "歲",
		dob: "出生日期",
		phone: "聯絡電話",
		idNumber: "證件號",
		project: "所屬項目",
		enrollDate: "入組日期",
		status: "入組狀態",
		doctor: "負責醫生",
		hospital: "所屬機構",
	},
	followupRecord: {
		recordTitle: "隨訪記錄",
		newRecord: "新增隨訪",
		emptyHint: "暫無隨訪記錄",
		actView: "查看",
		actEdit: "編輯",
		actDelete: "刪除",
		visitName: "訪視",
		dueDate: "應到日期",
		actualDate: "實際日期",
		statusPending: "未隨訪",
		statusOverdue: "已超窗",
		statusDone: "已隨訪",
		confirmCancel: "確認取消該次隨訪？",
		menuSelect: "範本選擇",
		menuDelete: "刪除範本",
		menuAdd: "新增非計劃隨訪",
		dialogSelectTitle: "選擇隨訪計劃範本",
		dialogAddTitle: "新增非計劃隨訪",
		fieldProjectName: "項目名稱：",
		fieldTemplate: "選擇範本：",
		fieldStart: "起始日期：",
		select: "請選擇",
		datePh: "選擇隨訪日期",
		ruleTemplate: "請選擇範本",
		ruleStart: "請選擇起始時間",
		generatePlan: "生成計劃",
		confirmDelete: "刪除後不可恢復，確認刪除？",
		dialogTipTitle: "提示",
		deleteSuccess: "刪除成功",
	},
	upgradation: {
		dialogTitle: "升級會員",
		selectLevel: "選擇會員等級",
		level: "等級",
		duration: "時長",
		monthly: "{n}個月",
		yearly: "{n}年",
		price: "價格",
		discount: "認證用戶享 5 折",
		payNow: "立即支付",
		paySuccess: "支付成功",
		payFailed: "支付失敗",
		qrTip: "請使用微信掃碼支付",
	},
	fileUpload: {
		click: "點擊上傳",
		drop: "或將檔案拖到此處",
		tip: "支援 JPG / PNG / PDF",
		preview: "預覽",
		download: "下載",
		remove: "刪除",
		removeConfirm: "確認移除該檔案？",
		uploading: "上傳中…",
		uploaded: "已上傳",
		uploadFailed: "上傳失敗",
		uploadFailedWithReason: "上傳被拒絕：{reason}",
		duplicateRejected: "重複檔案被拒絕——此檔案已為該病人上傳過。",
		exceed: "檔案數量超出限制",
		view: "查看",
		upload: "上傳",
		dialogUploadTitle: "上傳檔案",
		dialogViewTitle: "查看檔案",
		cancelUpload: "取消上傳",
		selectFile: "檔案上傳",
		dragHint: "拖拽檔案至此，或",
		clickToSelect: "選擇檔案上傳",
		aiOcr: "AI識別",
		submitted: "已提交識別",
		selectAll: "全選",
		selected: "已選 {n}",
		emptyData: "暫無資料",
	},
	patientList: {
		patientNoOrName: "患者編號/姓名：",
		enrollDate: "入組日期：",
		startDate: "開始時間",
		endDate: "結束時間",
		center: "所屬中心：",
		searchPlaceholder: "請輸入",
		searchKeyword: "請輸入關鍵字",
		searchBtn: "查 詢",
		resetBtn: "重 置",
		colIndex: "序號",
		colCompleteness: "完整度",
		colOperation: "操作",
		dragReorderTip: "拖動調整欄位順序（僅本機生效）",
		actDetail: "患者詳情",
		actFollowup: "隨訪詳情",
		actImaging: "影像",
		actTimeSeries: "時序",
		actDelete: "刪除資料",
		deleteSuccess: "刪除成功",
		deleteConfirm: "確認刪除此患者資料？該操作不可撤銷。",
		deleteTitle: "提示",
		add: "新增患者",
		export: "匯出",
		batchEnroll: "批次入組",
		import: "匯入",
		advancedFilter: "進階篩選",
		colPatientNo: "患者編號",
		colName: "姓名",
		colGender: "性別",
		colBirth: "出生日期",
		colAge: "年齡",
		colEnrollDate: "入組日期",
		colCenter: "所屬中心",
		genderMale: "男",
		genderFemale: "女",
		genderUnknown: "未知",
		ageYears: "歲",
		viewSource: "溯源",
	},
	patientDetail: {
		add: "新增患者",
		edit: "編輯患者",
		fileView: "患者檔案視圖",
		basicInfo: "基本資訊",
		save: "儲存",
		saveDraft: "暫存",
		discard: "放棄修改",
		nextForm: "下一步",
		prevForm: "上一步",
		visitRecords: "就診記錄",
		followups: "隨訪記錄",
		documents: "影像/檔案",
		newVisit: "新增就診",
		fieldRequired: "請輸入",
	},
	retrieval: {
		title: "資料檢索",
		exportTitle: "資料檢索-匯出",
		searchPlaceholder: "請輸入關鍵字",
		newQuery: "新建查詢",
		runQuery: "執行查詢",
		exportResult: "匯出結果",
		conditions: "篩選條件",
		results: "查詢結果",
		colIndex: "序號",
		colName: "查詢名稱",
		colCreatedAt: "建立時間",
		colOperation: "操作",
		actView: "查看",
		actEdit: "編輯",
		actDelete: "刪除",
		actExport: "匯出",
		actRun: "執行",
		deleteGroup: "刪除分組",
		selectValues: "請選擇值",
		enterValue: "請輸入值",
		fieldTreeFailed: "欄位列表載入失敗",
		selectAnalysisField: "請先選擇要分析的欄位",
		condition: {
			is: "等於",
			ne: "不等於",
			gt: "大於",
			gte: "大於等於",
			lt: "小於",
			lte: "小於等於",
			regex: "全部模糊匹配",
			exists: "是否存在",
			in: "在指定的陣列中",
			nin: "不在指定的陣列中",
			all: "陣列包含所有指定的元素",
			yes: "是",
			no: "否",
			and: "符合所有條件",
			or: "符合任意條件",
			nor: "均不符合條件",
		},
		stats: {
			title: "檢索結果統計",
			chart: "統計圖",
			chartTypePlaceholder: "請選擇分析圖形",
			startDate: "開始日期",
			endDate: "結束日期",
			startDatePlaceholder: "請選擇開始日期",
			endDatePlaceholder: "請選擇結束日期",
			barChart: "柱狀圖",
			pieChart: "餅狀圖",
			sampleSize: "樣本量",
			max: "最大值",
			min: "最小值",
			median: "中位數",
			avg: "平均數",
		},
		exportPage: {
			searchConditions: "檢索條件",
			saveAsTemplate: "儲存為範本",
			resultList: "檢索結果列表",
			colPatientNo: "患者編號",
			colPatientName: "患者姓名",
			colEnrollmentDate: "入組日期",
			colAge: "年齡",
			colBirthday: "出生日期",
			colDoctor: "負責醫生",
			colEnrollmentStatus: "入組狀態",
			colLastUpdated: "最近更新日期",
			colUpdatedBy: "最近更新用戶",
			colDataManage: "資料管理",
			patientDetail: "患者詳情",
			followUpDetail: "隨訪詳情",
			templateNamePlaceholder: "請輸入範本名稱",
			templateNameRequired: "請輸入範本名稱",
			templateSaved: "儲存範本成功",
			joinSubProject: "入組子項目",
			existingSubProjects: "已有子項目",
			subProjectName: "子項目名稱",
			projectStartDate: "項目啟動日期",
			projectEndDate: "項目結束日期",
			enrolledCount: "已入組人數",
			actEnrol: "入組",
			addSubProject: "新增子項目",
			basicInfo: "基本資訊",
			rootProjectName: "根項目名稱",
			projectLeader: "項目負責人",
			leaderUnit: "負責人單位",
			projectGoal: "項目目標",
			selectSubProject: "請選擇子項目",
		},
		exportDialog: {
			title: "資料匯出",
			exportAll: "匯出全部表單和模型",
			exportPartial: "匯出部分表單和模型",
			selectForms: "請選擇您要匯出的表單和模型",
			approvalConfirm: "本項目匯出需經審批通過後方可下載。是否提交匯出申請?",
			approvalTitle: "需要審批",
			submitRequest: "提交申請",
			requestId: "申請編號",
			status: "狀態",
			requestPending: "匯出申請已提交,等待審核人審批。可在「我的申請」中查看進度。",
			requestSubmitted: "匯出申請已提交",
			goToMyRequests: "前往我的申請",
		},
	},
	analysis: {
		title: "資料分析",
		runAnalysis: "執行分析",
		results: "分析結果",
		exportResult: "匯出報告",
		emptyHint: "請先選擇欄位並執行分析",
	},
	projectManage: {
		title: "項目列表",
		searchPlaceholder: "請輸入項目名稱",
		clearModelCache: "清除模型快取",
		clearModelCacheConfirm: "確認清除所有模型快取？清除後所有用戶首次載入會稍慢。",
		clearModelCacheTip: "提示",
		clearModelCacheSuccess: "快取已清除，共清除 {n} 條快取",
		newProject: "新建項目",
		colProjectId: "項目ID",
		colProjectName: "項目名稱",
		colProjectLeader: "項目負責人",
		colProjectTerm: "項目週期",
		colFollowupData: "隨訪資料",
		colViewInfo: "視圖資訊",
		colMainCenter: "主中心",
		colOperation: "操作",
		actEdit: "編輯項目",
		actScene: "應用情境",
		actDatabase: "資料庫設定",
		actFollowup: "隨訪設定",
		actPermissions: "人員權限",
		actSubCenter: "分中心管理",
		actSubProject: "子項目管理",
		actSchema: "架構初始生成",
		actAgent: "Agent設定",
		actMetadataHistory: "元數據歷史",
		actLifecycle: "生命週期與留存",
		actPiiRule: "PII規則設定",
		grpSetup: "設定",
		grpData: "資料",
		grpGovernance: "治理",
		grpStructure: "結構",
		lostFollowups: "丟失計劃隨訪條數 {n}",
		fixData: "修復資料",
		patientCount: "就診人:{p} ; 視圖列: {v};",
		patientViewMismatch: "---存在差異---",
		buildStatus: "建置狀態:{s} ;",
		buildBusy: "視圖建置中",
		buildIdle: "目前無任務",
		startTime: "開始時間:{t};",
		endTime: "結束時間:{t};",
		execResult: "執行結果:{r};",
		execSuccess: "成功",
		execFailed: "失敗",
		rebuildView: "重建視圖",
		appendView: "修補視圖",
		recalcCompleteness: "重算完整度",
		opSent: "請求已傳送",
		recalcDone: "重算完成，共處理 {n} 位患者",
		dialogBaseTitle: "基本資訊",
		dialogSceneTitle: "應用情境",
		fieldProjectName: "項目名稱",
		fieldProjectCode: "項目編碼",
		fieldProjectLeader: "項目負責人",
		fieldLeadCenter: "牽頭單位",
		fieldStartDate: "項目啟動日期",
		fieldEndDate: "項目結束日期",
		fieldTarget: "項目目標",
		fieldLeaderUnit: "負責人單位",
		fieldCompanyLogo: "公司Logo（橫版）",
		fieldSquareLogo: "方形Logo（圖標）",
		placeholderSelect: "請選擇",
		fieldSpecialty: "專科",
		fieldDisease: "疾病",
		fieldSoftwareEnv: "軟件環境",
		envWeb: "web",
		envDoctor: "醫生小程序",
		envPatient: "患者小程序",
		fieldLoginUrl: "項目登入頁URL",
		fieldLoginName: "項目登入頁名稱",
		fieldLoginImage: "項目登入頁圖片",
		searchPlaceholderRemote: "請輸入關鍵字",
	},
	equity: {
		accountInfo: "帳號資訊",
		username: "用戶名：",
		realNameAuth: "實名認證：",
		modify: "修改",
		notAuthHint: "目前您未完成資訊認證，無法享受五折優惠",
		goAuth: "去認證",
		levelExpire: "會員等級有效期：{date}",
		upgrade: "去升級會員",
		memberRights: "會員權益",
		categoryProjectMgmt: "項目管理",
		categoryAiCollect: "AI資料採集功能",
		categoryAiAnalysis: "AI資料分析功能",
		categoryIp: "知識產權服務",
		categoryResearch: "科研項目服務",
		rightCreateProject: "新建項目",
		rightCustomForm: "自訂表單",
		rightFollowup: "隨訪管理",
		rightEnrollment: "入組狀態管理",
		rightSubProject: "子項目管理",
		rightUnivariate: "單變數統計",
		rightSearch: "資料檢索",
		rightExport: "資料匯出",
		rightHistorical: "歷史資料入組新項目",
		rightAutoEnroll: "新資料自動納排",
		rightCrfGen: "自動生成CRF表",
		rightCrfFill: "自動填寫CRF表",
		rightPathology: "自動生成病理報告",
		rightFollowupChat: "互動式患者隨訪",
		rightAiSearch: "AI資料檢索",
		rightAiStat: "AI資料統計",
		rightAiExport: "AI資料篩選匯出",
		rightAiEnroll: "AI納排管理",
		rightIpFile: "知識產權申報",
		rightJointProject: "聯合項目申報",
		basicMember: "基礎會員",
		smartMember: "智慧會員",
		joint1Software: "免費申請聯合軟著1項",
		joint2Software: "免費申請獨立軟著2項",
		jointAiProject: "可聯合申報醫療人工智能項目",
		currentLevel: "當前等級",
		dialogAuthTitle: "資訊認證",
	},
	order: {
		searchPlaceholder: "請輸入訂單編號",
		orderList: "訂單列表",
		colIndex: "序號",
		colOrderNo: "訂單號",
		colPaymentTime: "交易時間",
		colPaymentFees: "交易金額",
		colPaymentMethod: "支付方式",
		methodWechat: "微信",
		colContent: "交易內容",
		colStatus: "目前狀態",
		colInvoiceStatus: "開票狀態",
		colOperation: "操作",
		actInvoice: "開票",
		statusCreated: "待支付",
		statusPayed: "已支付",
		statusUsed: "已使用",
		invoiceNotIssued: "未開票",
		invoiceIssued: "已開票",
		dialogTitle: "填寫開票資訊",
		titleSection: "抬頭資訊",
		fieldAmount: "發票金額",
		amountUnit: "元",
		fieldHeaderType: "抬頭類型",
		typePersonal: "個人/非企業單位",
		typeEnterprise: "企業",
		fieldInvoiceType: "發票類型",
		invoiceTypeValue: "增值稅普通電子發票",
		fieldHeader: "發票抬頭",
		placeholderInput: "請輸入",
		placeholderHeader: "請輸入發票抬頭",
		fieldTaxNumber: "納稅人識別號",
		placeholderTaxNumber: "請輸入15-20位的納稅人識別號",
	},
	subProjectManage: {
		title: "子項目列表",
		breadCrumb: "項目管理 / {parent}",
		newSubProject: "新建子項目",
		searchPlaceholder: "請輸入子項目名稱",
	},
	projectList: {
		projectCode: "項目編碼",
		centerCount: "中心數量",
		patientCount: "入組患者數量",
		subProjects: "子項目列表",
		openProject: "進入項目",
		emptyHint: "您還沒有任何項目，快去建立一個項目吧～",
		createProject: "建立項目",
		noticeSystem: "系統通知",
		noticeOcr: "OCR識別",
		noticeChallenge: "資料質疑",
	},
	projectHead: {
		projectName: "項目名稱",
		rootProjectName: "根項目名稱",
		subProjectName: "子項目名稱",
		parentProject: "關聯隊列項目",
		specialty: "關聯專科",
		disease: "關聯疾病",
		formConfig: "表單配置",
		followUpConfig: "隨訪配置",
	},
	home: {
		leadCentre: "牽頭單位",
		maskedHospital: "****醫院",
		projectLead: "項目負責人",
		projectTerm: "項目期限",
		pendingReply: "待回覆問診",
		clickToReply: "點擊查看並回覆 →",
		totalCases: "病例總數",
		newCasesThisMonth: "本月新增病例",
		avgCompleteness: "平均完整度",
		followUpOverdue: "隨訪超窗",
		view: "查看",
		notifications: "項目通知",
		index: "序號",
		notificationType: "通知類型",
		notificationContent: "通知內容",
		count: "人數",
		enrollmentTrend: "入組情況",
		genderRatio: "男女比例",
		ageDistribution: "年齡分佈",
	},
};
